<button class="btn btn-danger" (click)="open()" i18n="classification-image|@@classificationImage">
    Classification
</button>

<div [@openClose]="isOpen? 'open':'closed'" #drawerContent class="content" id='container1'>
    <div class="dismiss" (click)="close()">
        <i class="fa fa-times" aria-hidden="true"></i>
    </div>

    <app-image-classification *ngIf="currentImage !== undefined" [tchekId]='tchekId' [currentImage]='currentImage'
        [insideClassificationImage]='true'>
    </app-image-classification>

</div>


// WEBPACK FOOTER //
// ./src/app/element/classificationImageToggle/classificationImageToggle.component.html